import { useEffect } from 'react';
import { MBSentry } from './MBSentry';
import {
  CollectionViewScaleCounts,
  removeCollectionViewScaleSource,
  setCollectionViewScaleSource,
} from './collectionViewScale';

/**
 * Reports one data source's loaded/total entity counts into the collection
 * view's Sentry context. Grouped views call this once per group (via their
 * shared data hook); the registry sums across sources so long-task events carry
 * the whole view's scale.
 */
export function useReportCollectionViewScale({
  loadedEntityCount,
  totalEntityCount,
}: CollectionViewScaleCounts): void {
  useEffect(() => {
    const handle = Symbol('collectionViewScale');
    setCollectionViewScaleSource(handle, { loadedEntityCount, totalEntityCount });
    MBSentry.reportCollectionViewScale();
    return () => {
      removeCollectionViewScaleSource(handle);
      MBSentry.reportCollectionViewScale();
    };
  }, [loadedEntityCount, totalEntityCount]);
}

/**
 * Reports how many groups the mounted collection view renders — 0 when the view
 * is ungrouped.
 */
export function useReportCollectionViewGroupCount(groupCount: number): void {
  useEffect(() => {
    MBSentry.updateCollectionViewContext({ groupCount });
  }, [groupCount]);
}

/** Reports how many columns the mounted table view renders. */
export function useReportCollectionViewColumnCount(columnCount: number): void {
  useEffect(() => {
    MBSentry.updateCollectionViewContext({ columnCount });
  }, [columnCount]);
}
